// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    'aws_project_region': 'eu-west-2',
    'aws_cognito_identity_pool_id': 'eu-west-2:977491ef-15f7-4419-867e-da70855c4579',
    'aws_cognito_region': 'eu-west-2',
    'aws_user_pools_id': 'eu-west-2_3obN3CkQq',
    'aws_user_pools_web_client_id': '7du1i43pdcro1v8huivph9h5mt',
    'oauth': {
        'domain': 'betterspace-dev-prod.auth.eu-west-2.amazoncognito.com',
        'scope': [
            'phone',
            'email',
            'openid',
        ],
        'redirectSignIn': 'https://app.betterspace.uk/callback',
        'redirectSignOut': 'https://app.betterspace.uk/logout',
        'responseType': 'token'
    },
    'federationTarget': 'COGNITO_USER_POOLS',
    'aws_cloud_logic_custom': [
        {
            'name': 'AdminQueries',
            'endpoint': 'https://vdqml3nz7l.execute-api.eu-west-2.amazonaws.com/prod',
            'region': 'eu-west-2'
        }
    ],
    'aws_content_delivery_bucket': 'webapp-production-betterspace-prod',
    'aws_content_delivery_bucket_region': 'eu-west-2',
    'aws_content_delivery_url': 'https://d2jsds0awypz6o.cloudfront.net'
};


export default awsmobile;
